module.exports = __webpack_public_path__ + "img/fruzsina.6fa5c3f.jpeg";